import client from "../client";

export interface RPSFightRPSBetRequest {
  bet_result_id?: number;
  hashkey?: string;
}

export interface RPSFightRPSBetResponse {
  amount?: number;
}

export default function API(
  request: RPSFightRPSBetRequest
): Promise<RPSFightRPSBetResponse> {
  return client
    .post(`gameinhouse/rps/rps_fight_rps_bet`, request)
    .then((response) => response.data);
}
